import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface PaginationCSSStyle extends UIComponentCSSStyle
{
    getLeftArrowDivCSSStyle(): object;
    getRightArrowDivCSSStyle(): object; 
    getLeftArrowCSSStyle(): object;
    getRightArrowCSSStyle(): object;
}

export class PaginationCSSStyleImpl extends UIComponentCSSStyleImpl implements PaginationCSSStyle
{
    getLeftArrowDivCSSStyle(): object 
    {
       return {
        width:'100px',
        marginLeft: "20px",
        marginRight: "20px"
            //    width: '40px', 
            //    height: '100%', 
            //    position: 'relative', 
            //    display: 'flex', 
            //    alignItems: 'center', 
            //    justifyContent: 'center', 
            //    cursor: "pointer",
            //    left: "0px"
       };
    }

    getRightArrowDivCSSStyle(): object 
    {
       return {
            // width: '40px', 
            // height: '100%', 
            // position: 'relative', 
            // display: 'flex', 
            // cursor: "pointer",
            // alignItems: 'center', 
            // justifyContent: 'center', 
            // right: "0px"
            width:'100px',
            marginLeft: "20px",
            marginRight: "20px"
            
        };
    }

    getLeftArrowCSSStyle(): object 
    {
        return {
            position: 'relative', 
            border: "none",
            height: "12px",
            width: "12px",
            cursor: "pointer",
            marginRight:'30px'
        };
    }

    getRightArrowCSSStyle(): object 
    {
        return {
            position: 'relative', 
            border: "none",
            height: "12px",
            width: "12px",
            cursor: "pointer",
            marginLeft:'30px'
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/pagination/paginationcss.ts